import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { createContext, useContext } from 'react';
var VariantContext = /*#__PURE__*/createContext();
export function useVariant() {
  var variant = useContext(VariantContext);
  return variant ? Object.keys(variant).filter(function (key) {
    return variant[key];
  }) : null;
}
export function VariantProvider(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  var parentVariant = useVariant();
  return /*#__PURE__*/React.createElement(VariantContext.Provider, {
    value: props
  }, children);
}